import { Task } from "../../../../../../services/cloudchipr.api";

export const taskTargetAccountFilterText = ({ data }: { data?: Task }) => {
  return `${data?.target?.account?.provider_account_name} ${data?.target?.account?.provider_account_id} ${data?.target?.account?.provider}`;
};
